import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
@Component({
  selector: 'app-translate-page',
  templateUrl: './translate-page.component.html',
  styleUrls: ['./translate-page.component.css']
})
export class TranslatePageComponent implements OnInit {

  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
   
    this._activatedRoute.params.subscribe((params: Params) => { 
      var returnUrl = params['returnUrl']; //decodeURIComponent(params['returnUrl'] || '');     
      if (returnUrl) {
        this._router.navigateByUrl(returnUrl);
      } else {
        this._router.navigateByUrl('/');
      }
  }); 
  }

}
